import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showAllThemesAndItems } from "slices/discovery/discoverySlice";
import TableHeader from "layout/discovery/header/TableHeader";
import HeaderText from "layout/discovery/folder/categories/HeaderText";

const Header = ({ folderView }) => {
  const dispatch = useDispatch();

  const allThemes = useSelector((state) => state.discovery.themes);
  const themes = allThemes.filter((t) => t.GroupName !== "All Themes");
  const isSearch = useSelector((state) => state.discovery.config.isSearch);
  const filterView = useSelector((state) => state.discovery.config.filterView);
  const showAll = useSelector((state) => state.discovery.config.showAll);

  const dispatchShowAll = (isShowAll) => {
    dispatch(showAllThemesAndItems(!isShowAll));
  };

  useEffect(() => {
    dispatchShowAll(false);
  }, []);

  return (
    <div className="categories__header" data-testid="categories-header">
      <div className="categories__header__title">
        <HeaderText folderView={folderView} />
      </div>
      <div className="categories__header__table_header">
        <TableHeader
          themes={themes}
          isSearch={isSearch}
          showAll={showAll}
          filterView={filterView}
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  folderView: PropTypes.bool.isRequired,
};

export default Header;
